import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { transformSource } from '../../../utils/helpers';
import './Tooltip.sass';

interface Props {
	active?: boolean;
	content: string;
	id: string;
	arrowPlacement?: string;
}

function Tooltip({ content, id, arrowPlacement, active }: Props) {
	return (
		<div
			className={`ui-tooltip ${
				active ? 'ui-tooltip--active' : ''
			} ${arrowPlacement}`}
			data-id={id}
		>
			<div className="ui-tooltip__inner">
				{ReactHtmlParser(content, {
					transform: transformSource,
				})}
			</div>
		</div>
	);
}

Tooltip.defaultProps = {
	arrowPlacement: 'top-left',
};

export default Tooltip;
